<template lang="pug">
PageEmployees(v-if='!isSubPage')
PageEmployeesPage(v-else, :alias='alias')
</template>

<script lang="ts" setup>
const { isSubPage, alias } = useMeta();
</script>
